// Lib Imports
import React, { useContext } from 'react';
import { Layer, Box, Text, ThemeContext } from 'grommet';
import PropTypes from 'prop-types';
import { Close, StatusGoodSmall } from 'grommet-icons';
import Popconfirm from 'granite-admin/core/components/Popconfirm';
import styled from 'styled-components';
const BottomLayer = styled(Box)`
  transition: bottom 0.2s ease;
  z-index: 1000001;
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 22px 80px 12px #c5c7d0;
  flex-direction: row;
  display: flex;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`;
const Number = styled(Box)`
  width: 63px;
  color: #ffffff;
  font-size: 30px;
  background-color: #0085ff;
  border-radius: 5px 0px 0px 5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  cursor: default;
`;
const Action = styled(Box)`
  &:hover {
    cursor: pointer;
    > div > svg {
      stroke: #0085ff;
    }
  }
`;
const BulkActions = ({
  selected,
  close,
  label,
  bulkActions,
  bulkActionsComponent: BulkActionsComponent,
  newComponent = true
}) => {
  const theme = useContext(ThemeContext);
  const {
    bulkActionsComponent: ProjectBulkActions
  } = theme?.table;
  if (BulkActionsComponent) return /*#__PURE__*/React.createElement(BulkActions, {
    selected: selected,
    close: close,
    label: label,
    bulkActions: bulkActions
  });else if (ProjectBulkActions && newComponent) return /*#__PURE__*/React.createElement(ProjectBulkActions, {
    selected: selected,
    close: close,
    label: label,
    bulkActions: bulkActions,
    newComponent: false
  });
  return /*#__PURE__*/React.createElement(Layer, {
    margin: {
      bottom: '35px',
      horizontal: 'auto'
    },
    modal: false,
    position: 'bottom'
  }, /*#__PURE__*/React.createElement(BottomLayer, {
    justify: "between",
    width: "800px",
    height: "63px"
  }, /*#__PURE__*/React.createElement(Number, null, selected.length), /*#__PURE__*/React.createElement(Box, {
    width: "400px",
    justify: "start"
  }, /*#__PURE__*/React.createElement(Text, {
    margin: {
      vertical: 'auto',
      horizontal: 'small'
    },
    size: "24px",
    alignSelf: "start",
    color: "#323338"
  }, label, selected.length > 1 ? 's' : '', " Selected"), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    margin: {
      vertical: 'auto',
      horizontal: 'xsmall'
    },
    alignSelf: "start"
  }, selected.map(i => {
    return /*#__PURE__*/React.createElement(Box, {
      margin: {
        horizontal: 'xsmall',
        bottom: 'small'
      }
    }, /*#__PURE__*/React.createElement(StatusGoodSmall, {
      size: "16px",
      color: "rgb(120, 75, 209)"
    }));
  }))), /*#__PURE__*/React.createElement(Box, {
    direction: "row",
    width: "300px",
    justify: "end"
  }, bulkActions.map(action => {
    return /*#__PURE__*/React.createElement(Popconfirm, {
      onConfirm: () => action.onClick(selected)
    }, /*#__PURE__*/React.createElement(Action, {
      height: "63px",
      margin: {
        horizontal: 'small'
      },
      pad: "small",
      width: "63px"
    }, /*#__PURE__*/React.createElement(Box, {
      alignSelf: "center",
      pad: "xsmall"
    }, action.icon), /*#__PURE__*/React.createElement(Text, {
      pad: "small",
      alignSelf: "center"
    }, action.label)));
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "column",
    justify: "center",
    pad: "medium",
    border: {
      color: '#c5c7d0',
      size: '2px',
      style: 'solid',
      side: 'left'
    },
    onClick: () => close()
  }, /*#__PURE__*/React.createElement(Close, {
    size: "medium"
  })))));
};
BulkActions.propTypes = {
  close: PropTypes.func,
  selected: PropTypes.array,
  label: PropTypes.string,
  bulkActions: PropTypes.array
};
export default BulkActions;